import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styles'

const Section = ({ title, children, ...props }) => (
  <S.Container {...props}>
    <S.Title>{title}</S.Title>
    <div>{children}</div>
  </S.Container>
)

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Section
